import { render, staticRenderFns } from "./maintenance-feedback.vue?vue&type=template&id=dc8e76d2&scoped=true&"
import script from "./maintenance-feedback.vue?vue&type=script&lang=js&"
export * from "./maintenance-feedback.vue?vue&type=script&lang=js&"
import style0 from "./maintenance-feedback.vue?vue&type=style&index=0&id=dc8e76d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8e76d2",
  null
  
)

export default component.exports